import { render } from "./Lokasi.vue?vue&type=template&id=0059f9aa&scoped=true"
import script from "./Lokasi.vue?vue&type=script&lang=js"
export * from "./Lokasi.vue?vue&type=script&lang=js"

import "./Lokasi.vue?vue&type=style&index=0&id=0059f9aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0059f9aa"]])

export default __exports__